import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getListofUser = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/access/`,
    params: { page: 1, size: 500 },
  });
  return result;
};
export const cancelInviteUser = (user_id) => {
  let result = axios()({
    method: "post",
    url: `${API.USERList}${user_id}/cancel-invite/`,
  });
  return result;
};

export const createUser = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/user/`,
    data: data,
  });
  return result;
};

export const manageAppAccess = (account_id, user_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/user/${user_id}/access/`,
    data: data,
  });
  return result;
};

export const getAppAccess = (account_id, user_id, data) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/user/${user_id}/access/`,
    data: data,
  });
  return result;
};

export const changePassword = (user_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.USER}${user_id}/password/`,
    data: data,
  });
  return result;
};

export const resetPassword = (user_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.USER}${user_id}/password/`,
    data: data,
  });
  return result;
};

export const userStateUpdateSuspend = (account_id, access_id, data) => {
  // Handle case where arguments are passed as a single object
  if (typeof account_id === "object" && !access_id) {
    const params = account_id;
    account_id = params.accountId || params.account_id;
    access_id =
      params.accessId || params.access_id || params.userId || params.user_id;
    data = params.data || { state: "suspended" };
  }

  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/access/${access_id}/suspend/`,
    data: data,
  });
  return result;
};

export const userResendInvite = (user_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.USER}${user_id}/resend-invite/`,
    data: data,
  });
  return result;
};

export const userStateUpdateGiveBack = (account_id, access_id, data) => {
  // Handle case where arguments are passed as a single object
  if (typeof account_id === "object" && !access_id) {
    const params = account_id;
    account_id = params.accountId || params.account_id;
    access_id =
      params.accessId || params.access_id || params.userId || params.user_id;
    data = params.data || { state: "operational" };
  }

  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/access/${access_id}/un-suspend/`,
    data: data,
  });
  return result;
};

export const userStateUpdate = (account_id, user_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.ACCOUNTList}${account_id}/user/${user_id}/`,
    data: data,
  });
  return result;
};

export const userCheckEmail = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `api/common/account/${account_id}/test/email/`,
    data: data,
  });
  return result;
};

export const resetUserPassword = (data) => {
  let result = axios(false)({
    method: "post",
    url: `api/common/reset-password/`,
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return result;
};

export const sendNewPasswordData = (data) => {
  let result = axios(false)({
    method: "post",
    url: `api/common/user/reset/password/`,
    data: data,
    headers: {
      "Content-Type": "application/json",
    },
  });
  return result;
};

export const renameUser = (account_id, user_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/user/${user_id}/rename/`,
    data: data,
  });
  return result;
};

export const transferOwnerShip = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/change-owner/`,
    data: data,
  });
  return result;
};

export const partialUpdateUser = (user_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.USER}${user_id}/`,
    data: data,
  });
  return result;
};
export const userChangeEmail = (account_id, access_id, data) => {
  let result = axios()({
    method: "post",
    url: `api/common/slack/${account_id}/access/${access_id}/change-user/`,
    data: data,
  });
  return result;
};
export const getOperatingCountry = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/operating-country/`,
  });
  return result;
};
export const getCountryChatterList = (account_id, country_id, page = 1) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/operating-country/${country_id}/chatter/`,
    params: { page: page },
  });
  return result;
};
export const getOperatingCurrency = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/operating-currency/`,
    params: { page: 1, size: 500 },
  });
  return result;
};
export const addOperatingCurrency = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/operating-currency/`,
    data: data,
  });
  return result;
};
export const updateOperatingCountry = (account_id, id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/operating-country/${id}/`,
    data: data,
  });
  return result;
};
export const getCurrencies = () => {
  let result = axios()({
    method: "get",
    url: `api/common/currencies/`,
    params: { page: 1, size: 500 },
  });
  return result;
};
export const getCountryList = () => {
  let result = axios()({
    method: "get",
    url: `api/common/country/`,
    params: { page: 1, size: 500 },
  });
  return result;
};

export const addOperatingCountry = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/operating-country/`,
    data: data,
  });
  return result;
};

export const partialUpdateOperatingCountry = (account_id, id, data) => {
  let result = axios()({
    method: "PATCH",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/operating-country/${id}/`,
    data: data,
  });
  return result;
};

export const getUserChatter = (account_id, access_id, page = 1) => {
  let result = axios()({
    method: "get",
    url: `api/common/account/${account_id}/access/${access_id}/chatter/`,
    params: { page: page },
  });
  return result;
};
